// @flow
import produce from 'immer';
import {
  SET_EDITOR_ID,
  SET_PROMPTS,
  SET_API_CALL_IN_PROGRESS,
  SET_IMAGE_UPLOADING_IN_PROGRESS,
} from './actionTypes';

import type {
  CreateState,
  AvailablePrompts,
} from './types';
import {
  initialState,
} from './constants';

const handleSetPrompts = (
  state: CreateState,
  data: AvailablePrompts,
) => produce(state, draft => {
  draft.availablePrompts = data;
});

const handleSetId = (
  state: CreateState,
  data: string,
) => produce(state, draft => {
  draft.currentEditorId = data;
});
const handleSetApiCallInProgress = (
  state: CreateState,
  data: string,
) => produce(state, draft => {
  draft.apicallInProgress = data;
});

const handleSetImageUploadingInProgress = (
  state: CreateState,
  data: string,
) => produce(state, draft => {
  draft.imageUploadingInProgress = data;
});

const createReducer = (state: CreateState = initialState, action: *) => {
  switch (action.type) {
    case SET_PROMPTS:
      return handleSetPrompts(
        state,
        action.data,
      );
    case SET_EDITOR_ID:
      return handleSetId(
        state,
        action.data,
      );
    case SET_API_CALL_IN_PROGRESS:
      return handleSetApiCallInProgress(
        state,
        action.data,
      );
    case SET_IMAGE_UPLOADING_IN_PROGRESS:
      return handleSetImageUploadingInProgress(
        state,
        action.data,
      );
    default:
      return initialState;
  }
};

export default createReducer;
